module.exports = __webpack_public_path__ + "img/avatar_trollface.9c08dfba.svg";